<template>
    <div v-if="isLoaded">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document" :class="isTypeCatalog?'folder-modal':'file-modal'">
                <div class="modal-content">
                    <div class="modal-header p-2" style="height:64px">
                        <h5 class="modal-title">Metadata Request</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeMetadataManager">
                        <span aria-hidden="true">
                            <cancel-icon class="close-icon" style="height: 40px !important;
                                width: 40px !important;
                                color: #fff;">
                            </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body row">
                        <div v-if="!isTypeCatalog" class="col-md-6 selected-thumbnail-display h-100 p-1 m-0">
                            <div class="w-100" style="height:55% !important;display:flex;justify-content:center">
                            <template v-if="isVideoFile">
                                <div style="height:100%;width:100%;display:inline-block">
                                    <video-player ref="videoPlayerRef" id="video-player-id" @controller="setController" :isCurrentTimeUpdateRequired="true" :isProgressbarRequired="true" :options="videoOptions" @metaDataLoaded="videoPlaytoggle" style="height:100%;width:100%"/>
                                </div>
                                </template>
                                <audio v-if="isAudioFile" id="audio-player-id" class="audio-player" controls="controls" controlslist="nodownload">
                                <source :src="audioUrl" type="audio/mpeg" />
                                </audio>
                                <!-- <embed v-if="!isVideoFile" src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
                                <img v-if="isImageFile" :src="getThumbnailPath(assetDetails)" @error="replaceByDefaultImage">
                                <div v-if="assetDetails.state && assetDetails.state == 'OUTDATED'" class="outdated-text">
                                    OUTDATED
                                </div>
                            </div>
                            <div class="assets-details-in-metadata-manager" :style="isVideoFile?'height: 32% !important;margin-top: 63px;':'height:45% !important'">
                            <ul>
                                <li>
                                    <div class="key-style">Filename</div>
                                    <div class="value-style" style="overflow-wrap:anywhere">{{getFileName(assetDetails)}}</div>
                                </li>

                                <li v-if="startUpInfo.enable_reference_id_workflow && Object.keys(assetDetails).includes('reference_id') &&
                                    !['undefined',null].includes(assetDetails.reference_id) &&  assetDetails.reference_id.length > 0">
                                    <div class="key-style">{{startUpInfo.alias &&  startUpInfo.alias.alias_name?startUpInfo.alias.alias_name:"Reference ID"}}</div>
                                    <div class="value-style">{{assetDetails.reference_id}}</div>
                                </li>
                                <li>
                                    <div class="key-style">Path</div>
                                    <div class="value-style" style="overflow-wrap:anywhere">{{getFilePath(assetDetails)}}</div>
                                </li>
                                <li v-if="assetDetails.storage_class && assetDetails.storage_class.length > 0">
                                    <div class="key-style">Location</div>
                                    <div class="value-style">
                                        <div v-for="storageClass in assetDetails.storage_class" class="d-inline-flex" :key="storageClass">
                                            <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16" style="margin-top:2px !important">
                                                <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                                                <title>Archived</title>
                                            </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(assetDetails.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16" style="margin-top:2px !important">
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                            </svg>
                                            <span style="margin-inline-start:4px">{{ storageClass }}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="key-style">Date Added</div>
                                    <div class="value-style">{{getDateAndTimeInConfiguredFormat(assetDetails.added_datetime)}}</div>
                                </li>
                                <li>
                                    <div class="key-style">Date Created</div>
                                    <div class="value-style">{{getDateAndTimeInConfiguredFormat(assetDetails.created_datetime)}}</div>
                                </li>
                                <li>
                                    <div class="key-style">Size</div>
                                    <div class="value-style">{{humaniseSize(assetDetails.size)}}</div>
                                </li>
                                
                                <li v-if="'mime_type' in assetDetails && assetDetails.mime_type && assetDetails.mime_type.startsWith('video') &&
                                    'duration' in assetDetails && assetDetails.duration">
                                    <div class="key-style">Duration</div>
                                    <div class="value-style">{{getHumanReadableDuration(assetDetails.duration)}}</div>
                                </li>
                            </ul>
                            </div>
                        </div>
                        <div class="p-0 h-100 metadata-fields" :class="isTypeCatalog?'col-md-12':'col-md-6'" style="display:flex">
                            <sequence-metadata v-bind="selectedAssetInfo" style="width:100%;overflow:auto" :fixMinWidth="false" :screenType="selectedScreenType()" :parentData="getSelectedAssetDetails()" :enableMediaSlug="true" :enableOnlyFields="false" ref="sequenceMetadataModel"></sequence-metadata>
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style">
                        <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="closeMetadataManager">Cancel</button>
                        <button class="btn btn-outline-primary mr-3" @click='requestMetadataUpdate()'>
                            <span v-if="editInfo">Update request</span>
                            <span v-else>Request metadata update
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CancelIcon from "../core/InlineCancelField.vue";
import VideoPlayer from "../core/VideoPlayer.vue";
import "vue2-datepicker/index.css";
import {mapActions, mapGetters,mapMutations} from "vuex";
import Utils from "../../components.utils.js"
import SequenceMetadataComponent from "./SequenceMetadata.vue"
import RangeSliderMixins from '../../mixins/RangeSliderMixin.js';
import {NotifierConstants} from "../../components.constants.js";

export default {
    mixins:[RangeSliderMixins],
    props:["fileInfo","requestedMetadata","editInfo"],
    data() {
        return {
        isLoaded:false,
        assetId:null,
        time:null,
        assetDetails:{},
        route:"",
        editingMetadataKeyInDock:null,
        assetCustomMetadata : {"custom_metadata":[]},
        categoryName:"",
        actionsOnPlayer: false,
        audioUrl:null,
        controller:{},
        videoOptions: {
            autoplay: false,
            controls: true,
            nativeTextTracks: true,
            controlBar:{
                    'pictureInPictureToggle': false,
                    'progressControl': true,
                    'remainingTimeDisplay': false,

                volumePanel: {
                    inline: false,
                    vertical: true
                },
            },
            preload: "metadata", //loadmetadata such as duration required for range slider, won't load whole video
            sources: []
		}
    }
    },
    components:{
        "cancel-icon": CancelIcon,
        VideoPlayer: VideoPlayer,
        "sequence-metadata": SequenceMetadataComponent,
    },
    computed:{
        isTypeCatalog(){
            try {
                if('asset_type' in this.assetDetails){
                    return ["catalog"].includes(this.assetDetails.asset_type)
                }
            } catch (err) {
                console.error(`[isTypeCatalog][folder][Error while checking folderType-${err}]`)
            }
            return false
        },
        isAudioFile(){
            try {
                if('mime_type' in this.assetDetails){
                    return this.assetDetails.mime_type.startsWith("audio")
                }
            } catch (err) {
                console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
            }
            return false
        },
        isVideoFile(){
            try {
                if('mime_type' in this.assetDetails){
                    return this.assetDetails.mime_type.startsWith("video")  
                }
            } catch (err) {
                console.error(`[isVideoFile][files][Error while checking filetype-${err}]`)
            }
            return false
        },
        isImageFile(){
            try {
                if('mime_type' in this.assetDetails){
                    return this.assetDetails.mime_type.startsWith("image")  ||  this.assetDetails.mime_type.startsWith("audio")   || this.assetDetails.mime_type.startsWith("doc")
                }
            } catch (err) {
                console.error(`[isImageFile][files][Error while checking filetype-${err}]`)
            }
            return false
        },
        selectedAssetInfo(){
            return {parentData:this.assetDetails}
        },
        startUpInfo:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
        ...mapGetters("users",["getLoggedInUserPrivilege","getLoggedInUserId"])
    },
    methods: {
        getColorBasedOnExpiry(locationInfo,storage){
            return Utils.getAWSStorageIconColorBasedOnExpiry(locationInfo,storage)
        },
        videoPlaytoggle(){
            try{
                this.setProgressLabel(this.controller.player.duration());
            }catch(e){console.log(e)}
        },
        setProgressLabel(duration){
            try{
                [].forEach.call(document.querySelectorAll(`.player-current-time-division`),(el) => {
                    el.remove();
                });
            }catch(e){console.log(e)}
            let progressBar = this.$refs.videoPlayerRef.$el.querySelector('.vjs-control-bar');
            let currentProgressEl = document.createElement('div');
            currentProgressEl.classList.add('player-current-time-division');
            currentProgressEl.innerHTML = `<span class="currrent-time">${this.getDurationFormat(duration)}</span> <span class="time-division-label">/</span> <span class="full-time-of-time-division">${this.formatDurationHHMMSS_or_MMSS(duration)}</span>`;
            progressBar.insertBefore(currentProgressEl,progressBar.querySelector('.vjs-fullscreen-control.vjs-control'));
        },
        getDurationFormat(duration){
            const date = new Date(duration * 1000); // convert to milliseconds
            const hours = date.getUTCHours();
            if(hours > 0){
                return '00:00:00.00'
            }else{
                return '00:00.00'
            }
        },
        formatDurationHHMMSS_or_MMSS(duration) {
            return Utils.getExactDuationInSeconds(duration , this.frameRate, '.');
        },
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
            requestMetadataUpdate(){
                let state = "";
                if ("asset_state" in this.assetDetails){
                    state = this.assetDetails.asset_state
                }else{
                    state = this.assetDetails.state
                }
                if (state == "MARK FOR DELETE"){
                alert("Updating Metadata not available on deleted file(s)")
                }else{
                    let reqData = [];
                    let mData = this.$refs.sequenceMetadataModel.getSequenceMetadataMap();
                    for(let opKey of Object.keys(mData)){
                        let kId = "";
                        let mType = "";
                        let mVal = "";
                        if(opKey == "custom_metadata"){
                            let pChanged = false;
                            if((![undefined,null].includes(this.assetDetails[opKey]) && [undefined,null].includes(mData[opKey])) ||
                               (![undefined,null].includes(mData[opKey]) && [undefined,null].includes(this.assetDetails[opKey]) && mData[opKey].length > 0) ||
                               (![undefined,null].includes(mData[opKey]) && ![undefined,null].includes(this.assetDetails[opKey]) && mData[opKey].length != this.assetDetails[opKey].length)){
                                pChanged = true;
                            }
                            let isModified = false;
                            let pushEntry = false;
                            for(let fInfo of mData[opKey]){
                                let ei = this.assetDetails[opKey].findIndex(e => e.key_id == fInfo.key_id);
                                if(ei < 0){
                                    isModified = true;
                                }
                                if(isModified && pChanged){
                                    pushEntry = true;
                                }else if(ei >= 0){
                                    let findEntry = this.assetDetails[opKey][ei];
                                    if(["PICKLIST_MULTIVALUE","PICKLIST"].includes(findEntry.type)){
                                        for(let a of findEntry.value){
                                            if(!(fInfo.value).includes(a)){
                                                pushEntry = true;
                                                break;
                                            }
                                        }
                                    }else{
                                        if(findEntry.value[0] != fInfo.value[0]){
                                            pushEntry = true;
                                        }
                                    }
                                }
                                if(pushEntry){
                                    kId = fInfo.key_id;
                                    mType = fInfo.type;
                                    mVal = fInfo.value;
                                    if(![undefined, null].includes(mType) && mType.trim().length > 0){
                                        reqData.push({key_id:kId,metadta_type:mType,value:mVal})
                                        mType = ""
                                    }
                                }
                            }
                        }else if(opKey == "metadata"){
                            for(let mKey of Object.keys(mData[opKey])){
                                if(mKey == "description"){
                                    let isModified = false;
                                    if((![undefined,null].includes(this.assetDetails.metadata[mKey]) && [undefined,null].includes(mData.metadata[mKey])) ||
                                       (![undefined,null].includes(mData.metadata[mKey]) && [undefined,null].includes(this.assetDetails.metadata[mKey]) && mData.metadata[mKey].trim().length>0) ||
                                       (![undefined,null].includes(this.assetDetails.metadata[mKey]) && ![undefined,null].includes(mData.metadata[mKey]) &&
                                        this.assetDetails.metadata[mKey] != mData.metadata[mKey])){
                                        isModified = true;
                                    }
                                    if(isModified){
                                        kId = "description";
                                        mType = "FREETEXT_MULTILINE";
                                        mVal = mData.metadata[mKey];
                                    }
                                }else if(mKey == "tag_ids"){
                                    let isModified = false;
                                    if((![undefined,null].includes(this.assetDetails.metadata[mKey]) && [undefined,null].includes(mData.metadata[mKey])) ||
                                        (![undefined,null].includes(mData.metadata[mKey]) && [undefined,null].includes(this.assetDetails.metadata[mKey]) && mData.metadata[mKey].length > 0) ||
                                        (![undefined,null].includes(this.assetDetails.metadata[mKey]) && ![undefined,null].includes(mData.metadata[mKey]) &&
                                            this.assetDetails.metadata[mKey].length != mData.metadata[mKey].length)){
                                        isModified = true;
                                    }else{
                                        for(let i of mData.metadata[mKey]){
                                            let ei = this.assetDetails.metadata[mKey].findIndex(e => e == i);
                                            if(ei < 0){
                                                isModified = true;
                                            }
                                        }
                                    }
                                    if(isModified){
                                        kId = "tag";
                                        mType = "PICKLIST_MULTIVALUE";
                                        mVal = mData.metadata[mKey];
                                    }
                                }
                                if(mType.trim().length > 0){
                                    reqData.push({key_id:kId,metadta_type:mType,value:mVal})
                                    mType = ""
                                }
                            }
                        }else{
                            if(opKey == "slug_name"){
                                if(!this.isTypeCatalog){
                                if([undefined,null].includes(mData[opKey]) || mData[opKey].trim().length <= 0){
                                    alert("Empty slug is not allowed. Please add valid slug.");
                                    return;
                                }
                                let isModified = false;
                                if((![undefined,null].includes(this.assetDetails[opKey]) && [undefined,null].includes(mData[opKey])) ||
                                   (![undefined,null].includes(mData[opKey]) && [undefined,null].includes(this.assetDetails[opKey]) && mData[opKey].trim().length > 0) ||
                                   (![undefined,null].includes(mData[opKey]) && ![undefined,null].includes(this.assetDetails[opKey]) && mData[opKey].length != this.assetDetails[opKey].length)){
                                       isModified = true;
                               }
                               if(isModified){
                                    kId = "slug_name";
                                    mType = "FREETEXT_MULTILINE";
                                    mVal = mData[opKey];
                                }
                                }
                            }else if(opKey == "parent_id_path"){
                                if([undefined,null].includes(mData[opKey]) || mData[opKey].length <= 0){
                                    alert("Empty catalog is not allowed. Please add a catalog.");
                                    return;
                                }
                                let isModified = false;
                                let aCKey = "parent_id_path";
                                if("catalog_id_path" in this.assetDetails){
                                    aCKey = "catalog_id_path"
                                }
                                if((![undefined,null].includes(this.assetDetails[aCKey]) && [undefined,null].includes(mData[opKey])) ||
                                   (![undefined,null].includes(mData[opKey]) && [undefined,null].includes(this.assetDetails[aCKey])  && mData[aCKey].length > 0) ||
                                   (![undefined,null].includes(this.assetDetails[aCKey]) && ![undefined,null].includes(mData[opKey]) &&
                                      this.assetDetails[aCKey].length != mData[opKey].length)){
                                    isModified = true;
                                }else{
                                    for(let i of mData[opKey]){
                                        let ei = this.assetDetails[aCKey ].findIndex(e => e == i);
                                        if(ei < 0){
                                            isModified = true;
                                        }
                                    }
                                }
                                if(isModified){
                                    kId = "catalog";
                                    mType = "PICKLIST_MULTIVALUE";
                                    mVal = mData[opKey];
                                }
                            }
                            if(mType.trim().length > 0){
                                reqData.push({key_id:kId,metadta_type:mType,value:mVal})
                                mType =""
                            }
                        }
                    }
                    if(reqData.length > 0){
                        let payload = {};
                        payload.metadata_request = reqData;
                        if(this.editInfo){
                            payload["params"] = {
                                _id: this.requestedMetadata.request_id
                            }
                            this.updateRequestMetadata(payload).then((data)=>{
                                if (Utils.isAcceptedStatusCode(data.statusCode)){
                                    this.closeMetadataManager();
                                    this.$toast.success(data.message);
                                }else{
                                    this.$toast.error(data.message);
                                }
                            });
                        }else{
                            if ("asset_id" in this.assetDetails){
                                payload.asset_ids = [this.assetDetails.asset_id];
                            }else{
                                payload.asset_ids = [this.assetDetails._id];
                            }
                            this.addNewMetadataRequest(payload).then((data)=>{
                                if (Utils.isAcceptedStatusCode(data.statusCode)){
                                    this.closeMetadataManager();
                                    this.$toast.success(data.message);
                                }else{
                                    this.$toast.error(data.message);
                                }
                            });
                        }
                    }else{
                        alert(this.$t("Metadata request with out fields update is not supported.\nPlease update any field for metadata request."))
                        // this.closeMetadataManager();
                    }
                }
            },
            selectedScreenType(){
                if(this.isTypeCatalog){
                    return "Tag Metadata-Catalog";
                }
                return "Tag Metadata";
            },
            playSubclipMarkinMarkout(markinMarkoutObj){
                this.controller.player.currentTime(markinMarkoutObj.markin);
                this.controller.player.play();
                try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
                this.controller.player.on('timeupdate',() =>{ 
                if(this.controller.player.currentTime() >= markinMarkoutObj.markout){
                    this.controller.player.pause();
                    this.$refs.tagMetadataWindow.activeSubclipPreview = '';
                    try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
                    }
                });
            },
            openSubclipWindow(){
                this.$emit("openSubclipWindow",this.assetDetails)
            },
            getFileName(fileInfo){
                return fileInfo.file_name?fileInfo.file_name:fileInfo.slug_name
            },
            getFilePath(fileInfo){
                if ("path" in fileInfo){
                    return fileInfo.path
                }else{
                    return this.getCategoryRoutefromId(fileInfo.category_id)
                }
            },
            setController(controller){
                    this.controller = controller
            },
            showActionsOnPlayer(){
                this.actionsOnPlayer = ! this.actionsOnPlayer;
            },
            maximisePlayer(){
                this.$emit("maximisePlayer");
            },
            closeMiniPlayer(){
                this.$emit("closeMiniPlayer")
            },
            getThumbnailPath(file){
                return Utils.getThumbnailPathfromFileInfo(file)
            },
            getLowresPath(file){
                return Utils.getLowresPathfromFileInfo(file)
            },
            getAudiowaveform(file){
                return Utils.getAudiowaveformFromFileInfo(file)
            },
            getUnique(array){
                var uniqueArray = [];
            
                // Loop through array values
                for(let i=0; i < array.length; i++){
                    if(uniqueArray.indexOf(array[i]) === -1) {
                        uniqueArray.push(array[i]);
                    }
                }
                return uniqueArray;
            },
            closeMetadataManager(){
            this.$emit("close");
            },
            humaniseSize(bytes){
                let data = Utils.humanizeSize(bytes)
                return `${data["value"]} ${data["unit"]}`
            },
            getHumanReadableDuration(duration){
                return Utils.getDurationInSeconds(duration, true)
            },
            selectCategoryforAnAsset(){
                this.$emit("selectCategoryFromBrowse");
                this.cancelMetadataDockFields()
            },
            getCategoryRoutefromId(){
            return this.route
            },
            getSelectedAssetDetails(){
                let metadataInfo = JSON.parse(JSON.stringify(this.assetDetails));
                if(![undefined,null].includes(this.requestedMetadata) && Object.keys(this.requestedMetadata).length > 0){
                    let keyList = Object.keys(this.requestedMetadata);
                    if(keyList.includes("slug_name")){
                        metadataInfo["slug_name"] = this.requestedMetadata.slug_name;
                    }
                    if(keyList.includes("catalog_id_path")){
                        metadataInfo["parent_id_path"] = this.requestedMetadata.catalog_id_path;
                        metadataInfo["catalog_id_path"] = this.requestedMetadata.catalog_id_path;
                        let pList = []
                        for(let opn of this.requestedMetadata.catalog_info){
                            let pId = opn.catalog_id_path;
                            let pIdList = pId.split("/");
                            let cId = pIdList.splice((pIdList.length-1), 1)
                            let pIdName = opn.catalog_name_path;
                            let pIdNameList = pIdName.split("/");
                            let cIdName = pIdNameList.splice((pIdNameList.length-1), 1)
                            pList.push({
                                _id:cId[0],
                                catalog_name:cIdName[0],
                                parent_id_path:[pIdList.join("/")],
                                parent_path:{
                                    id:pIdList.join("/"),
                                    value:pIdNameList.join("/")
                                }
                            })
                        }
                        metadataInfo["parent_path"] = pList;
                        metadataInfo["catalog_path"] = pList;
                    }
                    if(keyList.includes("custom_metadata")){
                        for(let opn of this.requestedMetadata.custom_metadata){
                            let fIdx = this.assetDetails.custom_metadata.findIndex(op=>op.key_id == opn.key_id);
                            if(fIdx >= 0){
                                metadataInfo.custom_metadata[fIdx] = opn;
                            }else{
                                metadataInfo.custom_metadata.push(opn);
                            }
                        }
                    }
                    if(keyList.includes("metadata")){
                        let mkeyList = Object.keys(this.requestedMetadata.metadata)
                        let mDetails = {}
                        if(mkeyList.includes("tag_ids")){
                            mDetails["tag_ids"] = this.requestedMetadata.metadata.tag_ids
                            metadataInfo["tag_info"] = this.requestedMetadata.tag_info
                        }
                        if(mkeyList.includes("description")){
                            mDetails["description"] = this.requestedMetadata.metadata.description
                        }
                        if(Object.keys(mDetails).length > 0){
                            metadataInfo["metadata"] = mDetails;
                        }
                    }
                }
                return metadataInfo;
            },
            setAssetInfo(info){
                this.assetDetails = {}
                Object.assign(this.assetDetails, info)
                if(Object.keys(this.assetDetails).includes("custom_metadata")){
                    Object.assign(this.assetCustomMetadata["custom_metadata"], this.assetDetails.custom_metadata);
                }else{
                    this.assetDetails["custom_metadata"] = [];
                }
                if('mime_type' in this.assetDetails){
                    if (this.assetDetails.mime_type.startsWith("video")){
                        this.videoOptions.sources.push({
                                src:this.getLowresPath(this.assetDetails),
                                type: "video/mp4"
                            })
                    }else if (this.assetDetails.mime_type.startsWith("audio")){
                        this.audioUrl = this.getAudiowaveform(this.assetDetails)
                    }
                }
                this.isLoaded=true 
            },
            refreshFileInfoAndShowAsset(fileId){
                let payload = {}
                if (this.assetId && ["metadata-manager-display","catalogs-display"].includes(Utils.getCookieValue("context"))){
                    payload.params = {assetId: this.assetId}
                    this.getAssetInfoFromServer(payload).then((data) => {
                        this.setAssetInfo(data["asset"])
                    })
                }else{
                    payload.params = {fileId: fileId, metadata:true}
                    this.getFileInfoFromServer(payload).then((data) => {
                        this.setAssetInfo(data["file"])
                    })
                }
            },
            handleFileUpdateNotification(notification){
                if(notification.message){
                    let path = notification.message.path
                    let parent_path = notification.message.parent_path
                    if (this.assetDetails.path == path && 'mime_type' in this.assetDetails){
                        if (this.assetDetails.mime_type.startsWith("video")){
                            Object.assign(this.assetDetails, notification.message)

                            this.videoOptions.sources = [{
                                    src:this.getLowresPath(notification.message),
                                    type: "video/mp4"
                                }]
                            if (  this.controller.player){
                                this.controller.restartPlayer(this.videoOptions.sources[0])
                            }
                        }else if (this.assetDetails.mime_type.startsWith("audio")){
                            this.audioUrl = this.getAudiowaveform(this.assetDetails)
                        }else if (this.assetDetails.mime_type.startsWith("image")){
                            Object.assign(this.assetDetails, notification.message)
                        }
                        console.log(`[handleFileUpdateNotification][AssetDetails][File(${path}) updated in path->${parent_path}]`)
                    }
                }
            },
            registerforWebsocketNotifications(){
            this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"TagMetadata"})
            },
            unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"TagMetadata"})
            },
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("files", ["getFileInfoFromServer"]),
            ...mapActions("tags", ["getTagsOnAutocomplete"]),
            ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
            ...mapActions("assets", ["getAssetInfoFromServer"]),
            ...mapActions("assets",["getCategoryTreefromId"]),
            ...mapActions("metadataApprover",["addNewMetadataRequest","updateRequestMetadata"]),
    },
    beforeDestroy(){
        this.unRegisterforWebsocketNotifications()
    },
    created(){
        this.isLoaded=false 
        let assetOrFileId = ""
        if(this.fileInfo != undefined){
            if ("asset_id" in this.fileInfo){
                this.assetId = this.fileInfo.asset_id
            }else{
                this.assetId = this.fileInfo._id;
            }
            assetOrFileId = this.assetId;
        }
        if('file_uid' in this.fileInfo && this.fileInfo.file_uid != undefined){
            assetOrFileId = this.fileInfo.file_uid;
        }
        this.refreshFileInfoAndShowAsset(assetOrFileId)
        this.registerforWebsocketNotifications()
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #4a4a4a;
$background: #121212;
$background-color-on-hover: #141414;
$body-background-color: #141414;
$dull-text-color: #858585;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$table-border-color:1px solid #141414;
$active-blue: #007bff;
$danger-color: #dc3545 !important;
$input-field-bg-color: #121212;
$input-field-border-color: #202020;
$input-field-height:38px;
$button-height:38px;
$primary-background: #1a1e21;
$secondary-background-color: #15181B;
$secondary-border-color: 1px solid #2b2b2b;
$secondary-text-color: #9c9c9c;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#141414;
$scrollbar-thumb-on-hover-background:#555;
$input-field-padding:.375rem 10px;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$breadcrumb-background:#181818;
$mutliselect-tag-bg-color:#0a0a0a;
$mutliselect-all-tags-bg-color:#161616;
$multiselect-option-highlight-bg-color:#242424;
$multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
$learn-about-text-color:#e8912d;
$close-icon-bg-on-hover:#3a3a3a;
$svg-color:#9e9e9e;
$tags-background-color:#212121;
$tags-border-color:#2e2e2e;
$multiselect-tag-border-color:#292929;
$metadata-border-color:#303030;
$metadata-border-color-on-hover: #5a5a5a;
$metadata-field-bg-color: #181818;
$readOnly-bg-color: #1e2326 !important;

.li-style-change{
  background: $metadata-field-bg-color;
}

.readonlyDiv{
    background: $readOnly-bg-color;
    border: none !important;
}

.readonly-field{
  color:$dull-text-color;
  font-size:12px;
}

.folder-modal{
    width: 70vw;
    max-width:70%;
}
.file-modal{
    width: 100vw;
    max-width:100%;
}
.modal-dialog {
    margin: 0;
    height: 100vh;
    padding: 0;
  }
 
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background:$primary-background !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
    //   overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
  background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #141414;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #333;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}
.activeNav,.activeNav:hover{
    background: $body-background-color !important;
    color: $active-blue !important;
}
.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}

.metadata-fields{
  background: $primary-background;
  border-inline-start: $secondary-border-color !important;
}


.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-header .close {
    // margin: -1rem -19px -0rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:1%;
    height:52px;
    display:inline-flex !important;
    flex-wrap: nowrap !important;
    button{
        height: 37px !important;
        border-radius: 5px;
    font-size:14px;
    float:inline-end;
    }
}
.activeTag{
    color: $active-blue !important;
}

.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 7%;
    top: 45%;
}

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 45%;
}
.input-fields {
  border: none !important;
  min-width: 250Px;
  border-bottom: 1px solid $active-blue !important;
  padding-inline-start:5px;
  padding-top: 3px;
  height:38px;
}

.text-light{
  color: #b6b6b6 !important;
}

::v-deep{
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  background: #0a0a0a;
  border-bottom: 1px solid #3a3a3a;
}
.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
    background:$background;
}
.theme--light.v-chip {
    border-color:#3a3a3a !important;
    color:$text-color;
}

.theme--light.v-chip:not(.v-chip--active) {
    background: #121212;
}

.v-list-item--link:before{
  background-color:$background;
}
.vjs_video_3-dimensions, .video-js{
    height:350px !important;
    width:100% !important;
}
.video-js{
    height:350px !important;
    width:100% !important;
}
.player-current-time-division{
    width: auto !important;
}
}
.secondary-btn-style:hover{
  text-decoration: underline;
}

.assets-details-in-metadata-manager{
    // height:calc(100% - 348px);
    overflow:auto;
    padding:0px 15px;
    margin-top:5px;
}


// .input-fields {
//   border: none !important;
//   min-width: 250Px;
//   border: none !important;
//   border-bottom: 1px solid $active-blue !important;
// }

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:30%;
            text-align: start;
        }
        .value-style{
            color: #b6b6b6;
            width: 70%;
            text-align: start;
            padding-inline-start:5px !important
        }
    }
}


.selected-thumbnail-display{
    width: 100%;
    display: inline-block;
    max-width: 50%;
    img{
        height:100%;
        // width:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}


.audio-player{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}


.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

.outdated-text{
    position: absolute;
    top: 0px;
    font-weight: 500;
    background: #cf7f06;
    z-index: 0;
    width: 79px;
    text-align: center!important;
    height: 26px;
    padding-top: 3px;
    inset-inline-start:0px;
    font-size: 13px;
    border-radius: 5px;
}

</style>
